import React from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Image from "next/image";
import logos from "../../../assets/images/logos.png";
import ProductDetailsDescriptionTab from "./description-tab/description-tab";
import ProductDetailsDetailTab from "./detail-tab/detail-tab";
import ProductDetailsPriceBreakTab from "./pricebreak-tab/pricebreak-tab";
import { selectProduct } from "@/store/slices/product";
import { useSelector } from "react-redux";
import styles from "@/styles/product_detail.module.scss";

const ProductDetailsTab = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data) {
    return <></>;
  }
  return (
    <>
      <div className={styles.details_main}>
        <Tabs
          defaultActiveKey="first"
          id="product-details-tab"
          className={styles.nav_tabs}
        >
          <Tab eventKey="first" title="Description" className={styles.nav_link}>
            <div className={styles.details_text}>
              <ProductDetailsDescriptionTab />
            </div>
          </Tab>
          <Tab eventKey="second" title="Details">
            <div className={styles.details_text}>
              <ProductDetailsDetailTab />
            </div>
          </Tab>
          {productState.data.breakup_visibility == "1" && (
            <Tab eventKey="third" title="Price Break-up">
              <div className={styles.details_text}>
                <ProductDetailsPriceBreakTab />
              </div>
            </Tab>
          )}
          <Tab eventKey="fourth" title="Certificate Of Authenticity">
            <div className={styles.details_text}>
              <div className="row">
                <div className="col-md-6">
                  <p className={styles.certificate}>
                    CERTIFICATE OF AUTHENTICITY
                  </p>
                  <p>
                    Every piece of jewellery that we make is certified for
                    authenticity by third-party international laboratories like
                    SGL, IGI, BIS and GIA.
                  </p>
                </div>
                <div className="col-md-6">
                  <Image src={logos} alt="" />
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default ProductDetailsTab;
